import { createContext } from "react";

import {
  SignUpResponse,
  SignUpRequest,
  SignInRequest,
} from "services/HTTPService/responseRequestTypes";
import RegisterUserForm from "../../user/RegisterUserForm";
import User from "../../user/User";
import PartnerProfile from "../../user/partner/PartnerProfile";
import ClientProfile from "../../user/client/ClientProfile";

export type AuthContextType = {
  user: User | null;
  assignUser: (user: User) => void;

  partner: PartnerProfile | null;
  setPartner: (partner: PartnerProfile | null) => void;

  client: ClientProfile | null;
  setClient: (client: ClientProfile | null) => void;

  isLoading: boolean;

  signUp: (signUpData: RegisterUserForm) => Promise<void>;
  signIn: (
    signInData: SignInRequest,
    enabledAutoLogin: boolean
  ) => Promise<void>;
  logout: () => Promise<void>;
  verifyEmail: (oobCode: string) => Promise<void>;
  changePassword: (
    actualPassword: string,
    newPassword: string
  ) => Promise<void>;
  changeEmail: (
    currentEmail: string,
    newEmail: string,
    password: string
  ) => Promise<void>;
  sendPasswordReset: (email: string) => Promise<void>;
  resetPassword: (oobCode: string, newPassword: string) => Promise<void>;
  removeAccount: () => Promise<void>;
  recentlyLoggedOut: boolean;
};

const AuthContext = createContext<AuthContextType>({
  user: null,

  partner: null,
  setPartner: () => {
    // do nothing
  },

  client: null,
  setClient: () => {
    // do nothing
  },

  isLoading: false,

  recentlyLoggedOut: false,
  // @ts-ignore - empty function
  assignUser: () => {
    // do nothing
  },
  // @ts-ignore - empty function
  signUp: () => {
    // do nothing
  },
  // @ts-ignore - empty function
  signIn: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  logout: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  verifyEmail: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  changePassword: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  changeEmail: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  sendPasswordReset: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  resetPassword: () => {
    //do nothing
  },
  // @ts-ignore - empty function
  removeAccount: () => {
    //do nothing
  },
});

export default AuthContext;
